import React, { useState, useEffect } from 'react';
import ads from '../../Assets/Images/ads.jpg';
import CarFilter from './CarFilter';
import EditCarRequest from './EditCarRequest';
import CarPolicyListCompany from './CarPolicyListCompany';
import { useNavigate } from 'react-router-dom';

function CarPolicyList() {
    const navigate = useNavigate();
    const [storageChange, setStorageChange] = useState(false)
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]); //  to compare the data we are using this 
    function handleNavigate() {
        navigate(`${process.env.PUBLIC_URL}/motor-insurance/policy-compare-page`)
    }
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
        };
        // Set initial mobile state on component mount
        handleResize();
        // Add resize event listener to update mobile state
        window.addEventListener('resize', handleResize);
        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <>
            <CarFilter setStorageChange={setStorageChange} storageChange={storageChange}  />
            <div className={isMobile ? 'mb-5' : 'container mt-5 mb-5'}>
                <div className="row">
                    <div className="col-md-3">
                        <EditCarRequest setStorageChange={setStorageChange} storageChange={storageChange} />
                    </div>
                    <div className="col-md-6 ">
                        <CarPolicyListCompany
                            setStorageChange={setStorageChange}
                            storageChange={storageChange}
                            selectedCheckboxes={selectedCheckboxes}
                            setSelectedCheckboxes={setSelectedCheckboxes}
                        />
                    </div>
                    <div className="col-md-3 pt-5 ">
                        <div className=''>
                            <img src={ads} alt='' style={{ width: '306px', borderRadius: '5px' }} />
                        </div>
                        {selectedCheckboxes.length > 0 && (
                            <div className="selected-checkboxes-button" >
                                <button type="button" className="posp-button comparison-button" onClick={handleNavigate}>
                                    {`${selectedCheckboxes.length} items to compare `}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}

export default CarPolicyList;
